






















import {
  defineComponent,
  // watch
} from '@nuxtjs/composition-api';
import { useGoogleAnalytics, useUserAgent } from '~/compositions/useUtils';
export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: false,
      default: null,
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, _context) {
    const ga = useGoogleAnalytics();
    const ua = useUserAgent();

    // console.warn('⭐ シェアボタン ⭐');
    // console.warn(ua);
    const share = async () => {
      const share_title = props.title
        ? `Careermap|${props.title}`
        : 'Careermap';

      const share_url =
        props.url || window?.location?.toString() || 'https://www.careermap.jp';

      // console.warn('⭐⭐⭐ SNSシェアボタン ⭐⭐⭐');
      // console.warn(`タイトル=${props.title}`);
      // console.warn(`url=${props.url}`);
      // console.warn(`最終タイトル=${share_title}`);
      // console.warn(`最終URL=${share_url}`);

      // 【SNSシェアボタン】クリックをGAヒットとして送信
      ga.event({
        eventCategory: 'sns',
        eventAction: 'share',
        eventLabel: `title[${share_title}],url[${share_url}]`,
      });

      try {
        if (navigator.share) {
          await navigator.share({
            title: share_title,
            url: share_url,
          });
        } else {
          alert('Share Web APIをサポートしていません');
        }
      } catch (err) {
        // console.error('Share failed:', err.message);
      }
    };
    return { ua, share };
  },
});
